module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_03-f493f713f1a5dbb8e15579969284ceb5.jpg";